import React from 'react';

import { TemplateComponentProps } from '..';
import { TemplateCustom } from '../../../../../client/templates/templates';
import { TemplateFragment } from './TemplateFragment';

type Props = TemplateComponentProps<TemplateCustom>;

export const TemplateCustomComponent: React.FC<Props> = (props) => {
  const { notification } = props;
  const nfn = notification.notification;
  const layout = nfn.templateOptions.body.compositions[0]?.layout;
  const fallbackText = nfn.templateOptions.body.fallbackText;

  if (layout) {
    return (
      <TemplateFragment
        fragment={layout}
        templateData={nfn.templateData}
        fragmentIndex={0}
        notificationKey={`${notification.id}${notification.notification.date}`}
      />
    );
  } else if (fallbackText) {
    return <> {fallbackText} </>;
  }
  return <></>;
};
